// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vueEsign from 'vue-esign'
import axios from 'axios'
import './assets/css/common.css'
Vue.use(vueEsign)

Vue.config.productionTip = false

Vue.prototype.$http = axios


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js